module.exports = __webpack_public_path__ + "web/img/rmvb.8d929590.png";